/* 
Macht Bilder in Multirow-/Mehrreihig-Sektionen klickbar.
Verwendet den vorhandenen Button-Link für das Bild.
Updatesichere Lösung ohne Anpassung der Section-Datei.
*/

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.image-with-text__media').forEach(function (media) {
    
    const section = media.closest('.image-with-text');
    if (!section) return;

    const btn = section.querySelector('.button[href]');
    if (!btn) return;

    const link = btn.getAttribute('href');
    if (!link) return;

    if (media.querySelector('a')) return;

    const wrapper = document.createElement('a');
    wrapper.setAttribute('href', link);
    wrapper.setAttribute('aria-hidden', 'true');
    wrapper.setAttribute('tabindex', '-1');
    wrapper.style.display = 'block';

    while (media.firstChild) {
      wrapper.appendChild(media.firstChild);
    }

    media.appendChild(wrapper);
  });
});